module.exports = __webpack_public_path__ + "static/media/bars.e3d9bc9d.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/bars.svg
 ** module id = 873
 ** module chunks = 0
 **/